<template>
    <div class="modules content">
        <h1 class="title">
            <span class="left-line"></span>
            电子印章
            <span class="right-line"></span>
        </h1>
        <div class="modules-content center">
            <template>
                <div class="every-module campany-module-width"
                    :class="{'every-module-four':allowModules.length === 4}"
                     v-for="(module, index) in allowModules"
                     :key="index">
                    <div class="every-inner">
                        <router-link :to="module.link">
                            <div class="block-size vertical-center">
                                <svg class="icon home-fonticon"
                                    aria-hidden="true">
                                    <use :xlink:href="module.iconUrl"></use>
                                </svg>
                                <span style="display:block;">{{ module.name }}</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "Home",
    data () {
        return {
            // 菜单顺序和后端保持一致
            modules: [
                {
                    name: "个人签名",
                    link: "/personal",
                    iconUrl: "#iconperson-sign",
                    flag: 'PERSONAL_SIGN',
                },
                {
                    name: "印模管理",
                    link: "/mould",
                    iconUrl: "#iconaccess-management-01",
                    flag: 'SEAL_MOULD_MANAGE',
                },
                {
                    name: "印章管理",
                    link: "/seal",
                    iconUrl: "#iconseal",
                    flag: 'SEAL_MANAGE',
                },
                {
                    name: "当前印章",
                    link: "/currentseal",
                    iconUrl: "#iconnow-seal",
                    flag: 'CURRENT_SEAL',
                },
                // 2021.9.24,取消印章备案功能
                // {
                //     name: "印章备案",
                //     link: "/sealrecord/create",
                //     iconUrl: "#iconbeian"
                // },
                {
                    name: "我要签章",
                    link: "/signlist",
                    iconUrl: "#iconsign",
                    flag: 'SIGN',
                },
                {
                    name: "我要验签",
                    link: "/verify",
                    iconUrl: "#iconverify",
                    flag: 'VERIFY',
                },
                {
                    name: "访问管理",
                    link: "/access",
                    iconUrl: "#iconaccess-management-01",
                    flag: 'ACCESS_MANAGE',
                },
            ],
            currentModules: [],
        };
    },
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
        allowModules () {
            return this.modules.reduce((pre, cur) => {
                if (this.currentModules.includes(cur.flag)) {
                    pre.push(cur);
                }
                return pre;
            }, []);
        }
    },
    created() {
        this.getCurrentModules();
    },
    methods: {
        async getCurrentModules() {
            try {
                let resp = await this.axios({
                    url: '/menu/app',
                    method: 'GET',
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.currentModules = resp.result;
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.modules {
    margin: 0 auto;
    text-align: center;
    background-image: url(../../assets/images/personalCenter/backImg.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    flex: 1;
    width: 100%;

    .title {
        margin: 50px 0;
        .left-line,
        .right-line {
            display: inline-block;
            width: 130px;
            height: 2px;
            position: relative;
            top: -10px;
        }
        .left-line {
            background: linear-gradient(to left, @grey-light, @white);
        }
        .right-line {
            background: linear-gradient(to right, @grey-light, @white);
        }
    }
    .modules-content {
        display: flex;
        flex-wrap: wrap;
        max-width: @body-width;
        margin: 0 auto 40px;

        &.space-between {
            justify-content: space-between;
        }
        &.center {
            justify-content: center;
        }
    }
    .every-module {
        position: relative;
        width: 33%;
        height: 240px;
        background-image: url(../../assets/images/personalCenter/whiteBlock.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 5px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
            color: @theme-icon-color;
        }
        .every-inner {
            width: calc(~'100% - 18px');
            height: calc(~'100% - 25px');
            border: 1px solid #eeeeee;
            &:hover {
                border: 1px solid @theme-color;
            }
        }
    }
    // 2*2布局额外样式
    .every-module-four{
        width: 45%;
        .every-inner{
            width: calc(~'100% - 22px');
        }
    }
    .block-size {
        width: 100%;
        .home-fonticon {
            font-size: 80px;
        }
    }
}
</style>

